var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsUnpublished({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16821_19271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.59 13.5L18 16.09L15.41 13.5L14 14.91L16.59 17.5L14 20.09L15.41 21.5L18 18.91L20.59 21.5L22 20.09L19.41 17.5L22 14.91L20.59 13.5ZM18 7.5C12.47 7.5 8 11.97 8 17.5C8 23.03 12.47 27.5 18 27.5C23.53 27.5 28 23.03 28 17.5C28 11.97 23.53 7.5 18 7.5ZM18 25.5C13.59 25.5 10 21.91 10 17.5C10 13.09 13.59 9.5 18 9.5C22.41 9.5 26 13.09 26 17.5C26 21.91 22.41 25.5 18 25.5Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16821_19271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsUnpublished);
export default __webpack_public_path__ + "static/media/resultsUnpublished.05016ad74652152ed1084691d6527505.svg";
export { ForwardRef as ReactComponent };